/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Calm_Otter_RestInputs */

const en_brave_calm_otter_rest = /** @type {(inputs: Brave_Calm_Otter_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answered Questions`)
};

const de_brave_calm_otter_rest = /** @type {(inputs: Brave_Calm_Otter_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantwortete Fragen`)
};

/**
* | output |
* | --- |
* | "Answered Questions" |
*
* @param {Brave_Calm_Otter_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const brave_calm_otter_rest = /** @type {((inputs?: Brave_Calm_Otter_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Calm_Otter_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_brave_calm_otter_rest(inputs)
	return de_brave_calm_otter_rest(inputs)
});